import React, { Component } from "react";

import {
  Button,
  DatePicker,
  Select,
  message,
  AutoComplete,
  Input,
  Tag
} from "antd";
import Fetch from "../../utils/fetch";
import "./index.css";

const { Option } = Select;
const { CheckableTag } = Tag;
const { RangePicker } = DatePicker;

const STATUS_OPTIONS = [
  { key: "isInprogress", label: "INPROGRESS" },
  { key: "isCreated", label: "CREATED" },
  { key: "isClosed", label: "CLOSED" },
  { key: "isRejeted", label: "REJECTED" },
  { key: "isDev", label: "DEV" }
];

class crewTicketSearch extends Component {
  state = {
    showDatePicker: false,
    isRejeted: false,
    isDev: false,
    isClosed: false,
    isInprogress: true,
    isCreated: true,
    serviceType: null
  };

  async componentDidMount() {
    try {
      const complains = await this.fetchComplainCategory();
      const serviceHub = await this.fetchServiceHub();
      this.setState({ complains, serviceHub });
    } catch (err) {
      message.error(err);
    }
  }

  fetchComplainCategory = async () => {
    try {
      this.setState({ cancelLoader: true });
      const url = `/bus-tracker/callCategory/crewCategory`;

      const options = {
        method: "get"
      };

      const response = await Fetch(url, options);

      if (response) {
        this.setState({ cancelLoader: false });
        return response;
      } else {
        this.setState({ cancelLoader: false });
        return [];
      }
    } catch (err) {
      console.log(err);

      return [];
    }
  };

  fetchServiceHub = async () => {
    try {
      this.setState({ serviceHub: true });
      const url = `/bus-tracker/serviceHub`;

      const options = {
        method: "get"
      };

      const response = await Fetch(url, options);

      if (response) {
        this.setState({ cancelLoader: false });
        return response;
      } else {
        this.setState({ cancelLoader: false });
        return [];
      }
    } catch (err) {
      console.log(err);

      return [];
    }
  };

  fetchComplainOnStatus = key => {
    this.setState({ complainStatus: key });
  };

  fetchComplainOnHub = key => {
    this.setState({ hub: key });
  };

  fetchComplainOnRole = key => {
    this.setState({ role: key });
  };

  fetchComplainOnServiceType = key => {
    this.setState({ serviceType: key });
  };

  fetchComplainCustomTime = key => {
    const newCheck = key.target.value.replace(/[^\w\s]/gi, "");
    let value = parseInt(newCheck);
    if (value) {
      if (value > 12) {
        message.error("max time is 12 hrs");
      } else {
        if (
          value == 1 ||
          value == 2 ||
          value == 3 ||
          value == 4 ||
          value == 5 ||
          value == 6 ||
          value == 7 ||
          value == 8 ||
          value == 9 ||
          value == 10 ||
          value == 11 ||
          value == 12
        ) {
          this.setState({ time: parseInt(value) });
        }
      }
    }
  };

  fetchComplainOnTime = async key => {
    if (key != "") {
      this.setState({
        time: parseInt(key),
        showDatePicker: false,
        fromDate: null,
        toDate: null
      });
    }
    if (key == "custom") {
      this.setState({
        showDatePicker: true,
        fromDate: null,
        toDate: null
      });
    }
    if (key == "today") {
      this.setState({
        showDatePicker: false,
        fromDate: new Date().setHours(0, 0, 0, 0),
        toDate: new Date().setHours(23, 59, 59, 59)
      });
    }
    if (key == "yesterday") {
      this.setState({
        showDatePicker: false,
        fromDate: new Date().setHours(0, 0, 0, 0) - 86400000,
        toDate: new Date().setHours(23, 59, 59, 59) - 86400000
      });
    }
  };

  showResult = async () => {
    const {
      role,
      hub,
      fromDate,
      toDate,
      time,
      searchedComplain,
      PNRSearchValue,
      isRejeted,
      isDev,
      isClosed,
      isInprogress,
      isCreated,
      serviceType
    } = this.state;
    let body = {};
    this.props.showLoader();
    if (role) {
      body.role = role;
    }
    if (PNRSearchValue) {
      body.bookingCode = PNRSearchValue;
    }
    if (hub) {
      body.hub = hub;
    }
    if (
      searchedComplain &&
      Array.isArray(searchedComplain) &&
      searchedComplain.length > 0
    ) {
      body._id = searchedComplain[0]._id;
      if (searchedComplain[0]._id == "system") {
        body.type = searchedComplain[0].name;
      }
    }

    if (fromDate && toDate) {
      body.fromDate = fromDate.valueOf();
      body.toDate = toDate.valueOf();
    }
    if ((fromDate && !toDate) || (toDate && !fromDate)) {
      message.error("please select both date");
      return;
    }
    if (Number.isInteger(time)) {
      body.fromDate = Date.now() - time * 60 * 60 * 1000;
      body.toDate = Date.now();
    }
    body.complainStatus = "";

    if (isInprogress) {
      body.complainStatus += "INPROGRESS,";
    }
    if (isClosed) {
      body.complainStatus += "CLOSED,";
    }
    if (isRejeted) {
      body.complainStatus += "REJECTED,";
    }
    if (isDev) {
      body.complainStatus += "DEVELOPMENT_PHASE,";
    }
    if (isCreated) {
      body.complainStatus += "CREATED,";
    }
    if (serviceType) {
      body.serviceType = serviceType;
    }
    this.props.onSearch(body);
  };

  setValue = value => {
    const { complains } = this.state;
    let id = complains.filter(complain => complain.name === value);
    this.setState({ searchedComplain: id });
  };

  handlePNRSearch = event => {
    const newCheck = event.target.value.replace(/[^\w\s]/gi, "");
    this.setState({ PNRSearchValue: newCheck });
  };

  render() {
    const {
      fromDate,
      toDate,
      PNRSearchValue,
      showDatePicker,
      serviceHub,
      complains,
      isRejeted,
      isDev,
      isClosed,
      isInprogress,
      isCreated
    } = this.state;

    const statusState = { isInprogress, isCreated, isClosed, isRejeted, isDev };

    return (
      <div className="searchPanel">
        {/* Row 1: Category · PNR · Status */}
        <div className="searchRow">
          <div className="filterGroup">
            <span className="filterLabel">Category</span>
            <AutoComplete
              style={{ width: 240 }}
              placeholder="Search complaint category"
              dataSource={
                complains && Array.isArray(complains)
                  ? complains.map(complain => complain.name)
                  : null
              }
              onChange={value => this.setValue(value)}
              filterOption={(inputValue, option) =>
                option.props.children
                  .toUpperCase()
                  .indexOf(inputValue.toUpperCase()) !== -1
              }
            />
          </div>

          <div className="filterGroup">
            <span className="filterLabel">PNR</span>
            <Input
              placeholder="Search by PNR"
              value={PNRSearchValue}
              onChange={this.handlePNRSearch}
              style={{ width: 200 }}
              prefix={<span style={{ color: "#bbb" }}>🔍</span>}
            />
          </div>

          <div className="filterGroup">
            <span className="filterLabel">Status</span>
            <div className="statusTags">
              {STATUS_OPTIONS.map(({ key, label }) => (
                <CheckableTag
                  key={key}
                  checked={statusState[key]}
                  onChange={checked => this.setState({ [key]: checked })}
                >
                  {label}
                </CheckableTag>
              ))}
            </div>
          </div>
        </div>

        {/* Row 2: Dropdowns + Date Pickers + Search button */}
        <div className="searchRow">
          <div className="filterGroup">
            <span className="filterLabel">Hub</span>
            <Select
              style={{ width: 160 }}
              placeholder="All Hubs"
              allowClear
              onChange={this.fetchComplainOnHub}
            >
              {serviceHub && serviceHub.length > 0
                ? serviceHub.map(service => (
                    <Option value={service.name} key={service.name}>
                      {service.name}
                    </Option>
                  ))
                : null}
            </Select>
          </div>

          <div className="filterGroup">
            <span className="filterLabel">Role</span>
            <Select
              style={{ width: 160 }}
              placeholder="All Roles"
              allowClear
              onChange={this.fetchComplainOnRole}
            >
              <Option value="Crew Team">Crew Team</Option>
              <Option value="Customer Team">Customer Team</Option>
              <Option value="Route Manager">Route Manager</Option>
              <Option value="Incentive Team">Incentive Team</Option>
              <Option value="Cargo Team">Cargo Team</Option>
              <Option value="Ground Ops Team">Ground Ops Team</Option>
              <Option value="Legal Team">Legal Team</Option>
            </Select>
          </div>

          <div className="filterGroup">
            <span className="filterLabel">Service Type</span>
            <Select
              style={{ width: 130 }}
              placeholder="All Types"
              allowClear
              onChange={this.fetchComplainOnServiceType}
            >
              <Option value="ev">EV</Option>
              <Option value="maxx">Maxx</Option>
              <Option value="plus">Plus</Option>
            </Select>
          </div>

          <div className="filterGroup">
            <span className="filterLabel">Time</span>
            <Select
              style={{ width: 150 }}
              placeholder="Time Range"
              allowClear
              onChange={this.fetchComplainOnTime}
            >
              <Option value="1">Last 60 mins</Option>
              <Option value="4">Last 4 hrs</Option>
              <Option value="today">Today</Option>
              <Option value="yesterday">Yesterday</Option>
              <Option value="custom">Custom Range</Option>
            </Select>
          </div>

          {showDatePicker && (
            <div className="filterGroup">
              <span className="filterLabel">Date Range</span>
              <RangePicker
                value={fromDate && toDate ? [fromDate, toDate] : null}
                onChange={dates =>
                  this.setState({
                    fromDate: dates ? dates[0].startOf("day") : null,
                    toDate: dates ? dates[1].endOf("day") : null
                  })
                }
              />
            </div>
          )}

          <div className="filterGroup" style={{ justifyContent: "flex-end" }}>
            <span className="filterLabel">&nbsp;</span>
            <Button type="primary" onClick={this.showResult}>
              Search
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default crewTicketSearch;
